export default __webpack_public_path__ + "static/media/explosion.6ac2416c.wav";